import { DocumentDuplicateIcon } from '@heroicons/react/24/solid'
import axios from 'axios';
import React from 'react'
import { useRefresh } from '../../../../utils/RefreshProvider';
import useConfirmation from '../../../../utils/useConfirmation';
import Notify from '../../../../utils/useNotify';

export default function DuplicateProd({ slugProd, localhost, token, t }) {
  const { triggerRefresh } = useRefresh();
  const { open, ConfirmComponent } = useConfirmation();

  const handleConf = () => {
    open(
      {
        title: t("confirm-duplicate-product-header"),
        text: t("confirm-duplicate-product-text"),
        action: "add",
      },
      handleDuplicate
    );
  };

  const handleDuplicate = async () => {
    try {
      await axios.get(`${localhost}admin/duplicate-product/${slugProd}`, { headers: { Authorization: `Bearer ${token}` } });
      triggerRefresh();
      Notify('success', t("duplicate-product-success-toast"));
    } catch (err) {
      console.error(err);
      Notify('error', t("duplicate-product-error-toast"));
    }
  };

  return (
    <>
      {ConfirmComponent}
      <button data-tooltip-id="my-tooltip" data-tooltip-content={t("duplicate-product")} onClick={handleConf} type='button' className="text-black transition-colors duration-150 hover:bg-black/10 rounded-md p-1.5">
        <DocumentDuplicateIcon className="h-5 w-5" />
      </button>
    </>
  )
}
